import React, { useRef, useState } from "react";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import "../styles/doctorSignup.css";
import StripeCheckout from "react-stripe-checkout";
import Swal from "sweetalert2";

function ClinicSignup() {
  const handleClickPaymentButton = useRef(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const [passwordType, setPasswordType] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");
  const [clinicName, setClinicName] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("");

  const paymentButton = () => {
    handleClickPaymentButton.current.onClick();
  };

  const handlePasswordChange = (e) => {
    setPasswordInput(e.target.value);
  };

  const togglePassword = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const formData = {
      clinicName,
      email,
      phone, // ✅ Already full international format
      password: passwordInput,
      country,
    };

    localStorage.setItem("clinicFormData", JSON.stringify(formData));
    console.log("Submitting:", formData);

    onSignup(formData);
  };

  const onSignup = async (formData) => {
    const loader = Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const response = await fetch(
        "https://portal.virtualtriage.ca/api/v1/auth/clinic_signup/",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            clinic_name: formData.clinicName,
            email: formData.email,
            mobile_number: formData.phone,
            password: formData.password,
            location: formData.country,
          }),
        }
      );

      const data = await response.json();
      console.log(data);

      if (response.ok && data.status) {
        setShowPaymentModal(true);
        paymentButton();
      }

      loader.close();

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Your clinic signup request has been sent successfully",
      });
    } catch (error) {
      console.error("Error:", error);
      if (loader.isOpen) loader.close();

      Swal.fire({
        icon: "error",
        title: "Oops Error",
        text: "An error occurred. Please try again later.",
      });
    }
  };

  const onToken = async (token) => {
    const loader = Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    const formData = {
      email: email,
      charge_token: token.id,
      package_id: "2",
      card_details_status: "registration",
    };

    try {
      const response = await fetch(
        "https://portal.virtualtriage.ca/clinic_signup_with_package",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();
      console.log(data);
      loader.close();

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Your clinic account has been created successfully",
      }).then(() => {
        window.location.href = "https://virtualtriage.ai/";
      });
    } catch (error) {
      console.error("Error:", error);
      if (loader.isOpen) loader.close();

      Swal.fire({
        icon: "error",
        title: "Oops Error",
        text: "An error occurred. Please try again later.",
      });
    }
  };

  return (
    <div className="signup-page">
      <div className="signup-container">
        <div className="form-container">
          <img src="/assets/Virtual Triage.png" alt="Create Account" style={{ width: "50px" }} />
          <h3 className="form-title">Clinic Sign Up</h3>
          <form onSubmit={handleSubmit}>
            <div className="inputBox">
              <input
                className="input-field"
                type="text"
                name="ClinicName"
                placeholder="Enter Your Clinic Name"
                value={clinicName}
                onChange={(e) => setClinicName(e.target.value)}
              />
              <input
                className="input-field"
                type="email"
                name="Email"
                placeholder="Enter Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                className="input-field"
                type="address"
                name="Address"
                placeholder="Enter Your Address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />

              <PhoneInput
                country={"us"}
                value={phone}
                onChange={(phone) => setPhone(phone)}
                inputStyle={{ width: "100%" }}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
              />

              <div className="input-group">
                <input
                  className="input-field"
                  type={passwordType}
                  onChange={handlePasswordChange}
                  value={passwordInput}
                  name="password"
                  placeholder="Password"
                />
                <button type="button" className="eyebtn" onClick={togglePassword}>
                  {passwordType === "password" ? (
                    <i className="fas fa-eye-slash"></i>
                  ) : (
                    <i className="fas fa-eye"></i>
                  )}
                </button>
              </div>

              <select
                className="form-select"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
              >
                <option disabled value="">
                  Select Country
                </option>
                <option value="Canada">Canada</option>
                <option value="Pakistan">Pakistan</option>
                <option value="United States">United States</option>
                <option value="United Kingdom">United Kingdom</option>
              </select>
            </div>
            <div className="text-center">
              <button type="submit" className="submit-button">
                Continue
              </button>
              <StripeCheckout
                ref={handleClickPaymentButton}
                type="submit"
                value="Continue"
                style={{ display: "none" }}
                token={onToken}
                stripeKey="pk_live_51MkDNUKx0rXRL6v7CPCCeukNvoyvRBJJC8igLsmC1wR3BN4qx9BrAZ6VnZiy7Hqg0E3m4jg0esk8qFejT5HMRN3h00CCt4iMlG"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ClinicSignup;
